import { render, staticRenderFns } from "./AlternativeParts.vue?vue&type=template&id=20c94454"
import script from "./AlternativeParts.ts?vue&type=script&lang=ts&external"
export * from "./AlternativeParts.ts?vue&type=script&lang=ts&external"
import style0 from "./AlternativeParts.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports